<template>
  <div class="container">
    <!-- string value -->
    <div class="select-vari">
      <van-cell-group class="schedule-airport">
        <AirportSelector @selected="handleSelected" :default-airport="$route.query.currentAirport"
                         :placeholder="$t('Select an airport')"></AirportSelector>
      </van-cell-group>
    </div>

    <van-tabs v-model="activeTab" color="#1E44D5" class="van-vari">
      <van-tab :title="$t('Departures')">
        <van-pull-refresh v-model="refreshingDep" @refresh="onRefreshDep" :pulling-text="$t('Release to Refresh')"
                          :loosing-text="$t('Release to Refresh')"  :loading-text="$t('loding…')">
          <van-list class="flight-list"
                    :loading-text="$t('loding…')"
                    :finished-text="$t('No results to display')"
                    v-model="loadingDep"
                    :finished="finishedDep"
                    @load="getMoreDepFlights"
          >
            <van-cell>
              <van-row class="flight-list-header">
                <van-col span="5">{{ $t('Depart') }}</van-col>
                <van-col span="5">{{ $t('destination') }}</van-col>
                <van-col span="8">{{ $t('Status') }}</van-col>
                <van-col span="6">{{ $t('Flight') }}</van-col>
              </van-row>
            </van-cell>
            <van-cell
              v-for="(flight,index) in outFlights"
              :key="index"
              @click="showDetail(flight, 0)"
            >
              <van-row class="flight-list-item">
                <van-col span="5">{{renderTime(flight.FlightDeptimePlanDate )}}</van-col>
                <van-col span="5">{{flight.FlightArrcode}}</van-col>
                {{ (str = flight.FlightState[0].toUpperCase() + flight.FlightState.substring(1), void 0) }}
                <van-col span="8" :class="'flight-status-text ' + flight.FlightState">{{ $t(formatStatus(str, '0')) }}
                </van-col>
                <van-col span="6" class="flight-number"><img
                  :src="`/img/aircorp/${flight.FlightNo.substring(0, 2).toLowerCase()}.png`" alt="">{{flight.FlightNo}}
                </van-col>
              </van-row>
            </van-cell>
          </van-list>
        </van-pull-refresh>
      </van-tab>

      <van-tab :title="$t('Arrivals')">
        <van-pull-refresh v-model="refreshingArr" @refresh="onRefreshArr" :pulling-text="$t('Release to Refresh')">
          <van-list
            class="flight-list"
            :loading-text="$t('loding…')"
            :finished-text="$t('No results to display')"
            v-model="loadingArr"
            :finished="finishedArr"
            @load="getMoreArrFlights"
          >

            <van-cell>
              <van-row class="flight-list-header">
                <van-col span="5">{{ $t('Arrive') }}
                  <!--<van-icon name="arrow-up"></van-icon>-->
                </van-col>
                <van-col span="5">{{ $t('Origen') }}</van-col>
                <van-col span="8">{{ $t('Status') }}</van-col>
                <van-col span="6">{{ $t('Flight') }}</van-col>
              </van-row>
            </van-cell>

            <van-cell
              v-for="(flight,index) in inFlights"
              :key="index"
              @click="showDetail(flight, 1)"
            >
              <van-row class="flight-list-item">
                <van-col span="5">{{renderTime(flight.FlightArrtimePlanDate )}}</van-col>
                <van-col span="5">{{flight.FlightDepcode}}</van-col>
                {{ (str = flight.FlightState[0].toUpperCase() + flight.FlightState.substring(1), void 0) }}
                <van-col span="8" :class="'flight-status-text ' + flight.FlightState">{{ $t(formatStatus(str, '1')) }}
                </van-col>
                <van-col span="6" class="flight-number"><img
                  :src="`/img/aircorp/${flight.FlightNo.substring(0, 2).toLowerCase()}.png`" alt="">{{flight.FlightNo}}
                </van-col>
              </van-row>
            </van-cell>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
import AirportSelector from '../components/AirportSelector'

export default {
  name: 'Schedule',
  components: {
    AirportSelector
  },
  data () {
    return {
      activeTab: '',
      airports: [],
      selectedAirport: {},
      loadingDep: false,
      refreshingDep: false,
      loadingArr: false,
      refreshingArr: false,
      finishedDep: false,
      finishedArr: false,
      outList: {
        totalPage: 1,
        page: 0,
        data: [],
        sort: 'desc'
      },
      inList: {
        totalPage: 1,
        page: 0,
        data: [],
        sort: 'desc'
      }
    }
  },
  computed: {
    outFlights () {
      let data = []
      Object.assign(data, this.outList.data)
      return data.sort((a, b) => {
        return (new Date(a.FlightDeptimePlanDate.replace(/-/g, '/')).getTime()) - (new Date(b.FlightDeptimePlanDate.replace(/-/g, '/')).getTime())
      })
    },
    inFlights () {
      let data = []
      Object.assign(data, this.inList.data)
      return data.sort((a, b) => {
        return (new Date(a.FlightArrtimePlanDate.replace(/-/g, '/')).getTime()) - (new Date(b.FlightArrtimePlanDate.replace(/-/g, '/')).getTime())
      })
    }
  },
  methods: {
    airportText (item) {
      return `${item.code}--${item.airport}`
    },
    renderTime (date) {
      if (!date) {
        return '--:--'
      }
      return this.$moment(date).format('HH:mm')
    },
    formatStatus (status, isArrival) {
      if (isArrival == 1) {
        if (status === 'Schedule' || status === 'Departure') {
          return 'schedule'
        }
      }

      if (isArrival == 1 && status === 'Arrival') {
        return 'arrival'
      }

      if (status === 'Cruising' || status === 'Descending' || status === 'Landing' || status === 'Climbing') {
        return 'Departed'
      }

      if (status === 'Cancel in advance') {
        return 'Cancel'
      }
      return status
    },
    getMoreDepFlights () {
      this.getDepFlights(this.outList.page + 1)
    },
    getMoreArrFlights () {
      this.getArrFlights(this.inList.page + 1)
    },
    getDepFlights (page = 1) {
      if (page <= this.outList.totalPage) {
        this.getFlights('DEP', page, (data) => {
          this.outList.page = data.page
          this.outList.totalPage = data.totalpage
          this.outList.data.push(...data.data)
          this.finishedDep = data.page === data.totalpage
        })
      }
    },
    getArrFlights (page = 1) {
      if (page <= this.inList.totalPage) {
        this.getFlights('ARR', page, (data) => {
          this.inList.page = data.page
          this.inList.totalPage = data.totalpage
          this.inList.data.push(...data.data)
          this.finishedArr = data.page === data.totalpage
        })
      } else {
      }
    },
    stopLoading (direction) {
      switch (direction) {
        case 'DEP':
          this.loadingDep = false
          break
        case 'ARR':
          this.loadingArr = false
          break
      }
    },
    getFlights (direction, page, handler) {
      let airport = this.selectedAirport.code
      let url = this.$urlHelper.byAirport(airport, direction, page)
      this.$http.get(url).then(response => {
        if (response.status === 200 && response.data.count) {
          handler(response.data)
          this.stopLoading(direction)
        } else {
          this.stopLoading(direction)
          switch (direction) {
            case 'DEP':
              this.finishedDep = true
              break
            case 'ARR':
              this.finishedArr = true
          }
        }
      }).catch(e => {
        this.stopLoading(direction)
      })
    },
    showDetail (flight, isArrival) {
      localStorage.setItem('isArrival', isArrival)
      this.$store.state.flight = flight
      this.$store.commit('setFlight', flight)
      let fnum = flight.FlightNo
      let date = this.$moment(flight.FlightDeptimePlanDate).format('YYYY-MM-DD')
      let dep = flight.FlightDepcode
      let arr = flight.FlightArrcode
      this.$gtm.push({
        'event': 'screenview',
        'site_type': sessionStorage.getItem('site_type'),
        'brand': 'edreams',
        'screenName': '/flights-tracker/schedule/flights-detail/',
        'lang': localStorage.getItem('cod_lang') || localStorage.getItem('lang'),
        'cid': localStorage.getItem('cid')
      })
      this.$router.push(`/flight?fnum=${fnum}&dep=${dep}&arr=${arr}&date=${date}&cid=${localStorage.getItem('cid')}`)
    },
    handleSelected (option) {
      this.selectedAirport = option
    },
    onRefreshDep () {
      this.outList = {
        totalPage: 1,
        page: 0,
        data: [],
        sort: 'desc'
      }
      this.getDepFlights()
      setTimeout(() => {
        this.refreshingDep = false
      }, 500)
    },
    onRefreshArr () {
      this.inList = {
        totalPage: 1,
        page: 0,
        data: [],
        sort: 'desc'
      }
      this.getArrFlights()
      setTimeout(() => {
        this.refreshingArr = false
      }, 500)
    }
  },
  watch: {
    selectedAirport: {
      // immediate: true,
      handler () {
        if (!this.selectedAirport.code || this.selectedAirport.code.length !== 3) {
          return
        }
        this.finishedArr = false
        this.finishedDep = false
        this.inList = {
          totalPage: 1,
          page: 0,
          data: [],
          sort: 'desc'
        }
        this.outList = {
          totalPage: 1,
          page: 0,
          data: [],
          sort: 'desc'
        }
        this.getDepFlights()
        this.getArrFlights()
      }
    }
  }
}
</script>

<style scoped>
  .schedule-airport {
    display: flex;
    align-items: center;
  }

  .select-vari .menu {
    width: 100%;
  }

  .flight-number img {
    width: 18px;
    height: 18px;
    margin-right: 5px;
    vertical-align: middle;
    margin-bottom: 4px;
  }

  .flight-list-header .van-col {
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: normal;
    white-space: nowrap;
  }

  .van-vari {
    margin: -0.5px 7px 0;
  }

  .van-hairline--top-bottom::after {
    border-width: 0;
  }

  .van-cell {
    padding: 10px 0;
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell:not(:last-child)::after {
    border: 0;
  }
</style>
